import React, { useState } from "react";
import Field from "../../../../formComponents/formFields/field.component";
import get from "lodash/get";
import { useFormContext } from "react-hook-form";
import { StyledFeedbackTag } from "./feedbackTagsFields.style";

const FeedbackTag = ({
  settings = {},
  index,
  parentName,
  readOnly,
  values = {},
  append,
  lastVisibleIndex,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { name, id, _destroy } = settings;
  const [hidden, setHidden] = useState(false);

  const handleRemove = (e) => {
    e.preventDefault();
    setValue(`${parentName}.${index}.${_destroy.name}`, true);
    setHidden(true);
  };

  const handleAddField = (e) => {
    e.preventDefault();
    append({
      name: settings.name.default,
      _destroy: settings._destroy.default,
    });
  };

  const isLastVisibleIndex = lastVisibleIndex === index;
  return (
    <StyledFeedbackTag $hidden={hidden ? 1 : 0} $readOnly={readOnly ? 1 : 0}>
      {values.id && (
        <input
          type="hidden"
          {...register(`${parentName}.${index}.${id.name}`)}
        />
      )}
      <input
        type="hidden"
        {...register(`${parentName}.${index}.${_destroy.name}`, {
          value: values._destroy || _destroy.default,
        })}
      />
      <Field
        {...name}
        value={values.name || name.default}
        name={`${parentName}.${index}.${name.name}`}
        register={register}
        error={get(errors, `${parentName}.${index}.${name.name}`)}
        readOnly={readOnly}
      />
      <div className="controls">
        {!readOnly && (
          <a href="#" onClick={handleRemove}>
            – Remove tag
          </a>
        )}
        {isLastVisibleIndex && (
          <a href="#" onClick={handleAddField}>
            + Add another tag
          </a>
        )}
      </div>
      {!readOnly && !isLastVisibleIndex && <hr />}
    </StyledFeedbackTag>
  );
};

export default FeedbackTag;
